export enum CareDocumentType {
  PersonalisedCarePlan = 'pcp',
  WorkFocusedPlan = 'work-focused-plan',
  EndOfCareSummary = 'end-of-care-summary',
  InterimCareSummary = 'interim-care-summary',
  InitialAssessmentSummary = 'initial-assessment-summary',
}

export function displayEbpDocumentType(type: CareDocumentType) {
  switch (type) {
    case CareDocumentType.PersonalisedCarePlan:
      return 'Personalised Care Plan';
    case CareDocumentType.WorkFocusedPlan:
      return 'Work Focused Plan';
    case CareDocumentType.InterimCareSummary:
      return 'Interim Care Summary';
    case CareDocumentType.InitialAssessmentSummary:
      return 'Initial Assessment Summary';
    case CareDocumentType.EndOfCareSummary:
      return 'End of Care Summary';
    default:
      throw new Error(`Unknown EBP document type: ${type}`);
  }
}

export function getEbpDocumentApiRoute(type: CareDocumentType) {
  switch (type) {
    case CareDocumentType.PersonalisedCarePlan:
      return 'pcps';
    case CareDocumentType.WorkFocusedPlan:
      return 'work-focused-plans';
    case CareDocumentType.InterimCareSummary:
      return 'interim-care-summaries';
    case CareDocumentType.InitialAssessmentSummary:
      return 'initial-assessment-summaries';
    case CareDocumentType.EndOfCareSummary:
      return 'end-of-care-summaries';
    default:
      throw new Error(`Unknown EBP document type: ${type}`);
  }
}
